'use client';

import React, {useState, useEffect} from 'react';
import MobileSingerSwiper from './mobile-singer-swiper';
import DesktopSingerSwiper from './desktop-singer-swiper';

interface Singer {
    id: number;
    name: string;
    imageUrl: string;
    category: string;
}

interface SingerSwiperProps {
    singers: Singer[];
    renderCard: (singer: Singer, isMobile: boolean) => React.ReactNode;
    autoPlay?: boolean;
    autoPlayInterval?: number;
    isSectionInViewPort?: boolean;
}

const SingerSwiper: React.FC<SingerSwiperProps> = ({
    singers,
    renderCard,
    autoPlay = true,
    autoPlayInterval = 1000,
    isSectionInViewPort
}) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 769);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Render component tương ứng
    if (isMobile) {
        return (
            <MobileSingerSwiper
                singers={singers}
                renderCard={renderCard}
                autoPlay={autoPlay}
                autoPlayInterval={autoPlayInterval}
                isSectionInViewPort={isSectionInViewPort}
            />
        );
    }

    return (
        <DesktopSingerSwiper
            singers={singers}
            renderCard={renderCard}
            autoPlay={autoPlay}
            autoPlayInterval={autoPlayInterval}
            isSectionInViewPort={isSectionInViewPort}
        />
    );
};

export default SingerSwiper;
